
define('text!editor/edit/layers/add/legend/index.html',[],function () { return '<div id="legend-editor" data-bind="compose: content"></div>';});

